import React, { Component } from 'react';
import { Sidebar } from 'semantic-ui-react';

import MatterportFrame from './MatterportFrame';
import MiniMap from './MiniMap';
import DebugPanel from './DebugPanel';
import FullScreenButton from './FullScreenButton';
import Toggle from './Toggle';
import Scene360 from './Scene360';
import SidebarMenu from './SidebarMenu';

export default class MapContainer extends Component {
  state = {
    currentMap: this.props.data.maps[0],
    minimapMouseData: { position: { x: 0, y: 0 }, minimapState: {} },
    minimapClosed: true,
    firstLoad: true,
    is360: false,
    showSidebar: true
  };

  constructor(props) {
    super(props);

    this.handlePointSelect = this.handlePointSelect.bind(this);
    this.renderDebugPanel = this.renderDebugPanel.bind(this);
  }

  handlePointSelect(point) {
    this.setState({ currentMap: point, firstLoad: false, is360: point.is360 });
  }

  renderDebugPanel(mouseData) {
    return (
      <DebugPanel
        url={this.state.currentMap.url}
        x={mouseData.position.x || 0}
        y={mouseData.position.y || 0}
        minimapInfo={mouseData.minimapState}
        percentage={{
          x:
            (mouseData.position.x /
              (mouseData.minimapState.width * mouseData.minimapState.zoom)) *
            100,
          y:
            (mouseData.position.y /
              (mouseData.minimapState.height * mouseData.minimapState.zoom)) *
            100
        }}
      />
    );
  }

  render() {
    const mouseData = this.state.minimapMouseData;
    const containerStyle = this.props.fullscreen
      ? styles.containerFS
      : styles.container;
    return (
      <div
        style={{
          ...styles.container
        }}
      >
        <Sidebar.Pusher
          style={{ width: '100%', height: '100%', margin: 0, padding: 0 }}
        >
          {!this.state.is360 && (
            <MatterportFrame
              onLoad={this.props.onLoad}
              url={this.state.currentMap.url}
              autoload={this.props.data.autoload}
              firstLoad={this.state.firstLoad}
            />
          )}
          {this.state.is360 && (
            <Scene360
              onLoad={this.props.onLoad}
              data={this.state.currentMap}
              defaultColor="#ff3434"
              onLinkClick={(toId, e) => {
                console.log(
                  `A Link to ${toId} was clicked. Here is the event:`,
                  e
                );
                const newPoint = this.props.data.maps.filter(
                  point => parseInt(point.id) === parseInt(toId)
                );
                if (newPoint.length > 0) {
                  this.handlePointSelect(newPoint[0]);
                } else {
                  console.log(`That ID doesn't exist!`);
                }
              }}
            />
          )}
        </Sidebar.Pusher>
        <SidebarMenu
          visible={this.state.showSidebar}
          onPointSelect={this.handlePointSelect}
          data={this.props.data}
          onClose={() => this.setState({ showSidebar: false })}
        />
        <MiniMap
          minWidth={100}
          currentMap={this.state.currentMap}
          data={this.props.data}
          onPointSelect={this.handlePointSelect}
          onMouseMove={data => this.setState({ minimapMouseData: data })}
          visible={!this.state.minimapClosed}
          onClose={() => this.setState({ minimapClosed: true })}
        />
        <FullScreenButton
          fullscreen={this.props.fullscreen}
          onChangeFullscreen={this.props.onChangeFullscreen}
        />
        {window.innerWidth >= 500 &&
          window.innerHeight >= 500 && (
            <Toggle
              visible={this.state.minimapClosed}
              onClick={() => this.setState({ minimapClosed: false })}
              icon="map"
              style={{ right: 68 }}
            />
          )}

        <Toggle
          visible={true}
          onClick={() => this.setState({ showSidebar: true })}
          icon="list"
          style={{ left: 10 }}
        />
        {this.props.data.debugMode && this.renderDebugPanel(mouseData)}
      </div>
    );
  }
}

const styles = {
  container: {
    position: 'absolute',
    display: 'block',
    background: '#000',
    margin: 'auto',
    width: '100%',
    height: '100%',
    maxWidth: '100vw',
    maxHeight: '100vh',
    objectFit: 'contain'
  }
};



// WEBPACK FOOTER //
// ./src/components/MapContainer.js